import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import Modal from "@/features/shared/components/Modal/Modal";
import ChargeTableFilters from "@/features/charge/components/ChargeTableFilters";
import ChargeTable from "@/features/charge/components/ChargeTable";
import ChargePagination from "@/features/charge/components/ChargePagination";
import ChargeForm from "@/features/charge/components/ChargeForm";
import useCharges from "@/features/charge/hooks/useCharges";
import { toast } from "react-toastify";
const ChargesPage = () => {
    const [filters, setFilters] = useState({ label: '' });
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedCharge, setSelectedCharge] = useState(null);
    const [errors, setErrors] = useState(null);
    // useCharges hook automatically refetches when page or filters change
    const { charges, chargeMetaData, chargesLoading, chargeError, handleAddCharge, handleUpdateCharge, handleDeleteCharge, refetchCharges, } = useCharges(currentPage, filters, false, rowsPerPage);
    const handleFilterChange = (filterName, value) => {
        setFilters((prev) => ({ ...prev, [filterName]: value }));
        setCurrentPage(1); // Reset to first page on filter change
        // The hook's query key updates automatically, triggering a refetch.
    };
    const handleAddChargeClick = () => {
        setSelectedCharge(null);
        setIsModalVisible(true);
    };
    const handleEdit = (charge) => {
        setSelectedCharge(charge);
        setIsModalVisible(true);
    };
    const handleDelete = async (idCharge) => {
        try {
            setErrors(null);
            await handleDeleteCharge(idCharge);
            toast.success("Charge supprimée");
        }
        catch (error) {
            setErrors(error.message);
            toast.error(`Erreur : ${error.message}`);
        }
    };
    const handleSubmit = async (chargeData) => {
        try {
            setErrors(null);
            if (selectedCharge && chargeData.id) {
                await handleUpdateCharge(chargeData);
                toast.success("Charge mise à jour avec succès");
            }
            else {
                await handleAddCharge(chargeData);
                toast.success("Charge ajoutée avec succès");
            }
            setIsModalVisible(false);
            // Optionally, call refetchCharges() if needed.
        }
        catch (error) {
            setErrors(error.message);
            toast.error(`Erreur : ${error.message}`);
        }
    };
    // Display loading and error states before rendering main content.
    if (chargesLoading) {
        return _jsx("div", { className: "p-4", children: "Chargement..." });
    }
    if (chargeError) {
        return (_jsxs("div", { className: "p-4 text-red-500", children: ["Erreur lors du chargement des charges : ", chargeError, _jsx("button", { onClick: () => refetchCharges(), className: "ml-4 bg-blue-500 text-white px-2 py-1 rounded", children: "R\u00E9essayer" })] }));
    }
    return (_jsxs("div", { className: "p-4 bg-gray-50 min-h-screen", children: [_jsx("div", { className: "flex flex-col sm:flex-row justify-end", children: _jsx("div", { children: _jsx("button", { onClick: handleAddChargeClick, className: "mb-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600", children: "+ Ajouter une charge" }) }) }), _jsx(ChargeTableFilters, { filters: filters, onFilterChange: handleFilterChange }), _jsx(ChargeTable, { charges: charges, onEdit: handleEdit, onDelete: handleDelete }), chargeMetaData && (_jsx(ChargePagination, { currentPage: chargeMetaData.page ?? 1, totalPages: chargeMetaData.totalPages ?? 1, limit: rowsPerPage, onPageChange: (page) => setCurrentPage(page), onLimitChange: (value) => {
                    setRowsPerPage(value);
                    setCurrentPage(1);
                } })), isModalVisible && (_jsx(Modal, { onClose: () => setIsModalVisible(false), children: _jsx(ChargeForm, { initialData: selectedCharge ?? undefined, onSubmit: handleSubmit, onCancel: () => setIsModalVisible(false) }) })), errors && (_jsxs("div", { className: "mt-4 p-3 bg-red-100 text-red-700 rounded", children: ["Erreur : ", errors] }))] }));
};
export default ChargesPage;
